// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 432 ? "ca5b25d4" : chunkId) + "." + {"20":"6f031934e254eab1","432":"b8b5303e66a5e7fa","480":"ed2b508a0f1340fa","651":"60a192374d46ce2e"}[chunkId] + ".js";
};